import Vue from 'vue'
import VueRouter from 'vue-router'

import SiteLayout from '@/views/layout/SiteLayout'



const LoginView = () => import('@/views/site/LoginView')

//User Views


Vue.use(VueRouter)

var routes;
var siteRoutesArray = [ //Routes for sites
    { path: '', component: LoginView, name: 'Login', meta: { title: 'Login' } },
];

routes = [{
    path: '/',
    component: SiteLayout,
    children: siteRoutesArray
},]

const router = new VueRouter({
    mode: 'history',
    base: process.env.PUBLIC_PATH,
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (to.hash) {
            return { selector: to.hash }
        } else {
            return { x: 0, y: 0 };
        }
    }
})

export default router